export const SHADOWS = {
  Shadow1: '0px 2px 4px rgba(0, 0, 0, 0.15)',
  Shadow2: '0px 4px 8px rgba(0, 0, 0, 0.15)',
  Shadow3: '0px 8px 16px rgba(0, 0, 0, 0.15)',
  ShadowCentered: '0px 0px 6px rgba(0, 0, 0, 0.1), 0px 4px 10px rgba(0, 0, 0, 0.1 )',
};